import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { KeyRound } from 'lucide-react';
import { useSpc } from '../context/SpcContext';

export default function PinResetGate() {
  const { user, setMemberPin, toast } = useSpc();
  const [pinInput, setPinInput] = useState('');
  const [busy, setBusy] = useState(false);

  const shouldShow = !!user && !!user.requiresPinReset && user.approvalStatus === 'approved';
  if (!shouldShow) return null;

  const submit = async () => {
    const digits = pinInput.trim();
    if (!/^\d{4}$/.test(digits)) { toast && toast('Enter exactly 4 digits'); return; }
    setBusy(true);
    const ok = await setMemberPin(digits);
    setBusy(false);
    if (ok) setPinInput('');
  };

  return (
    <AnimatePresence>
      <motion.div
        className="welcome-backdrop"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        data-testid="pin-reset-gate"
      >
        <motion.div
          className="welcome-card"
          initial={{ scale: 0.85, opacity: 0, y: 30 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 220, damping: 22 }}
        >
          <div className="welcome-body">
            <div className="welcome-icon"><KeyRound size={38} /></div>
            <h2 data-testid="pin-reset-title">Pick a new Member PIN</h2>
            <p>
              We found another member sharing your old PIN, so for security it can no longer be used to check in.
              Choose your own fresh 4-digit PIN — it'll also become your new referral code. This only takes a second.
            </p>
            <div className="pin-reset-input-row">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={4}
                placeholder="0000"
                autoFocus
                value={pinInput}
                onChange={(e) => setPinInput(e.target.value.replace(/\D/g, '').slice(0, 4))}
                onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                data-testid="pin-reset-input"
                className="pin-reset-input"
              />
              <button
                type="button"
                className="btn"
                data-testid="pin-reset-submit-btn"
                disabled={busy || pinInput.length !== 4}
                onClick={submit}
              >
                {busy ? 'Saving…' : 'SET MY NEW PIN'}
              </button>
            </div>
            <div className="pin-reset-hint">{pinInput.length}/4 digits entered — must be unique to you</div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
